import React from 'react';

export default class TooltipIE11 extends React.Component {
      render() {
        const { children, text, forceShow, forceHide } = this.props;

        let boxClass = "tooltip-box";

        if (forceShow) {
            boxClass += " show";
        } else if (forceHide) {
            boxClass += " hide";
        }

        return (
            <div className="tooltip-container">
                {children}
                <div className={boxClass}>{text}</div>
            </div>
        );
    }
}
